// extracted by mini-css-extract-plugin
export default {"wrapper":"NoteContent_wrapper__Gdxhd","bottom_spacer":"NoteContent_bottom_spacer__r7d68","save_final_row":"NoteContent_save_final_row__wrv6G"};